import api from '@/configs/GlobalRequestHandler.js';

export default {
  getStatus: () => api.getRequest('/user/legal/status'),
  accept: (body) => api.postRequestWithBody('/user/legal/accept', body),
  getPublic: () => api.getRequest('/legal'),
  getPublicByType: (type) => api.getRequest(`/legal/${type}`),
  adminList: (type) => api.getRequest(`/admin/legal?type=${type}`),
  adminPublish: (body) => api.postRequestWithBody('/admin/legal/publish', body),
};
